import { AppMenuItem, PermissionInput } from '@/core/permissions/permission.model';

/**
 * Paleta do circulo do icone no popover do `app-botao-acoes`. O `styleClass` do item
 * e concatenado na bolinha (botao-acoes.html), entao espera-se um utilitario de fundo.
 */
export const COR_ACAO = {
    novo: 'bg-green-500',
    editar: 'bg-blue-500',
    salvar: 'bg-indigo-500',
    cancelar: 'bg-red-500',
    remover: 'bg-red-500',
    info: 'bg-cyan-600',
    neutro: 'bg-purple-500'
} as const;

export type CorAcao = keyof typeof COR_ACAO;

/** Acao existe, mas nao se aplica ao estado atual: cinza e sem clique — nunca sumindo. */
export const COR_DESABILITADO = 'bg-gray-500';

export interface AcaoMenuItemConfig {
    /** Estavel: o popover faz track por `id ?? label`, e varios labels aqui sao dinamicos. */
    id: string;
    label: string;
    icon: string;
    cor: CorAcao;
    disabled?: boolean;
    permission?: PermissionInput;
    command: () => void;
}

/**
 * Monta um item do menu de acoes mantendo `disabled` e `styleClass` em sincronia — os dois
 * precisam virar juntos, e e justamente ai que a versao escrita a mao desanda.
 */
export function acaoMenuItem(cfg: AcaoMenuItemConfig): AppMenuItem {
    const disabled = cfg.disabled ?? false;

    const item: AppMenuItem = {
        id: cfg.id,
        label: cfg.label,
        icon: cfg.icon,
        styleClass: disabled ? COR_DESABILITADO : COR_ACAO[cfg.cor],
        disabled,
        command: () => cfg.command()
    };

    // Ausente e diferente de indefinido: o guard de dev checa a presenca da chave.
    if (cfg.permission) {
        item.permission = cfg.permission;
    }

    return item;
}
